/* Greenwipes theme behaviour.
   Reveal-on-scroll and the header scroll state are ported directly from the
   DCLogic components in the source design files. */
(function () {
  'use strict';

  var EASE = 'cubic-bezier(.22,.61,.36,1)';

  /* ---------------------------------------------------------- Reveal --- */
  /* Matches _setupReveal() in the source: only elements that start below
     92% of the viewport are armed, each honouring data-reveal-delay. */
  function setupReveal() {
    var nodes = document.querySelectorAll('[data-reveal]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-revealed'); }, delay);
        io.unobserve(el);
      });
    }, { threshold: 0.12 });

    Array.prototype.forEach.call(nodes, function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top > window.innerHeight * 0.92) {
        el.classList.add('gw-reveal-armed');
        el.style.transition = 'opacity .75s ' + EASE + ', transform .75s ' + EASE;
        io.observe(el);
      }
    });
  }

  /* ---------------------------------------------------- Sticky header --- */
  /* Transparent over the video hero, solid past 40px — same threshold as
     the source component state. */
  function setupHeader() {
    var header = document.querySelector('[data-gw-header]');
    if (!header) return;

    if (header.classList.contains('gw-header--overlay')) {
      var scrolled = false;
      var onScroll = function () {
        var next = window.scrollY > 40;
        if (next === scrolled) return;
        scrolled = next;
        header.classList.toggle('is-scrolled', scrolled);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var burger = header.querySelector('[data-gw-burger]');
    var menu = document.querySelector('[data-gw-mobile-menu]');
    if (burger && menu) {
      burger.addEventListener('click', function () {
        var open = burger.getAttribute('aria-expanded') === 'true';
        burger.setAttribute('aria-expanded', open ? 'false' : 'true');
        menu.classList.toggle('is-open', !open);
      });
    }
  }

  /* ------------------------------------------------------- Hero video --- */
  function setupHeroVideo() {
    var video = document.getElementById('gw-hero-video');
    if (!video) return;
    video.muted = true;
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
  }

  /* -------------------------------------------------- Resource filter --- */
  function setupResourceFilters() {
    var root = document.querySelector('[data-gw-resource-library]');
    if (!root) return;

    var buttons = root.querySelectorAll('[data-gw-filter]');
    var cards = root.querySelectorAll('[data-gw-resource-type]');

    Array.prototype.forEach.call(buttons, function (button) {
      button.addEventListener('click', function () {
        var value = button.getAttribute('data-gw-filter');

        Array.prototype.forEach.call(buttons, function (other) {
          var active = other === button;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        Array.prototype.forEach.call(cards, function (card) {
          var match = value === 'all' || card.getAttribute('data-gw-resource-type') === value;
          card.hidden = !match;
        });
      });
    });
  }

  /* --------------------------------------------------------- Product --- */
  function setupProduct() {
    var root = document.querySelector('[data-gw-product]');
    if (!root) return;

    /* Gallery */
    var mainImage = root.querySelector('[data-gw-main-image]');
    var thumbs = root.querySelectorAll('[data-gw-thumb]');
    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-gw-thumb');
        var alt = thumb.getAttribute('data-gw-thumb-alt') || '';
        if (mainImage && src) {
          mainImage.setAttribute('src', src);
          mainImage.setAttribute('srcset', '');
          mainImage.setAttribute('alt', alt);
        }
        Array.prototype.forEach.call(thumbs, function (other) {
          other.classList.toggle('is-active', other === thumb);
        });
      });
    });

    /* Quantity stepper */
    var qtyInput = root.querySelector('[data-gw-qty-input]');
    var steppers = root.querySelectorAll('[data-gw-qty-step]');
    Array.prototype.forEach.call(steppers, function (button) {
      button.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(button.getAttribute('data-gw-qty-step'), 10) || 1;
        var next = (parseInt(qtyInput.value, 10) || 1) + step;
        qtyInput.value = next < 1 ? 1 : next;
      });
    });

    /* Variant selection — rebuilds the option triplet and posts the id */
    var variantData = root.querySelector('[data-gw-variants]');
    if (!variantData) return;

    var variants;
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      return;
    }

    var selects = root.querySelectorAll('[data-gw-option-index]');
    var idField = root.querySelector('[data-gw-variant-id]');
    var priceEl = root.querySelector('[data-gw-price]');
    var submit = root.querySelector('[data-gw-submit]');
    if (!selects.length || !idField) return;

    function onChange() {
      var chosen = Array.prototype.map.call(selects, function (select) { return select.value; });
      var match = null;

      for (var i = 0; i < variants.length; i++) {
        var options = variants[i].options || [];
        var same = true;
        for (var j = 0; j < chosen.length; j++) {
          if (options[j] !== chosen[j]) { same = false; break; }
        }
        if (same) { match = variants[i]; break; }
      }

      if (!match) {
        idField.value = '';
        if (submit) {
          submit.disabled = true;
          submit.textContent = submit.getAttribute('data-gw-unavailable') || 'Unavailable';
        }
        return;
      }

      idField.value = match.id;
      if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available
          ? (submit.getAttribute('data-gw-add') || 'Add to cart')
          : (submit.getAttribute('data-gw-soldout') || 'Sold out');
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    Array.prototype.forEach.call(selects, function (select) {
      select.addEventListener('change', onChange);
    });
  }

  /* -------------------------------------------------- Contact anchors --- */
  /* Ported from the Contact component: arriving on #gw-distributor
     preselects the Distribution interest and scrolls to that card. */
  function setupContactAnchor() {
    if (window.location.hash !== '#gw-distributor') return;

    var group = document.querySelector('[data-gw-interests]');
    if (group) {
      var radios = group.querySelectorAll('input[type="radio"]');
      Array.prototype.forEach.call(radios, function (radio) {
        if (radio.value.toLowerCase() === 'distribution') radio.checked = true;
      });
    }

    setTimeout(function () {
      var target = document.getElementById('gw-distributor');
      if (!target) return;
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - 90,
        behavior: 'smooth'
      });
    }, 150);
  }

  function init() {
    setupHeader();
    setupHeroVideo();
    setupReveal();
    setupResourceFilters();
    setupProduct();
    setupContactAnchor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run when a section is re-rendered in the theme editor. */
  document.addEventListener('shopify:section:load', function () {
    setupHeader();
    setupHeroVideo();
    setupResourceFilters();
    setupProduct();
  });
})();
